
	export default {
		props: {
			allTags: Object,
		},
		methods: {
			filterContent() {
				this.$emit("filter-content", this.$parent.selectedTags);
			}
		}
	}
